import UserShieldColor from './UserShieldColour.svg';
import UserShieldDark from './UserShieldDark.svg';
import UserShieldLight from './UserShieldLight.svg';
export const userShield = { color: UserShieldColor, dark: UserShieldDark, light: UserShieldLight };
//# sourceMappingURL=index.js.map